var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform, Type } from 'class-transformer';
import { PlanDetailsModel } from '../plan-details/plan-detail';
import { AccountModel } from '../account/account';
import { UserModel } from '../user/user';
export class UserSettings {
    userId;
    hideKibanaSearchTooltip;
    kibanaTheme;
    allowSupport;
    externalLogin;
    insightsDisplayed;
    logzioTheme;
}
class AccountSettings {
    /** The consolidated AI setting (ORIONIQ-1645). Optional until gaia-full's phase 1 is deployed everywhere. */
    aiEnabled;
    aiInvocationsEnabled;
    aiPromptsEnabled;
    insightsEnabled;
    labsEnabled;
    welcomeFlowCurrentStep;
}
export class UserSession {
    accountId;
    accountType;
    sessionId;
    userId;
    username;
    fullName;
    userToken;
    accountState;
    indexPrefix;
    kibanaTheme;
    role;
    permissions;
    created;
    userRegistered;
    lastActivityDate;
    expirationDateInSeconds;
    inSupportAccess;
    supportUserId;
    supportUsername;
    supportFullName;
    admin;
}
export class UserSummary {
    accountState;
    planType;
    listenerAddress;
    accountEsIndexPrefix;
    accountRegion;
    canManuallyAddUsers;
    /** @deprecated Use session.account.id instead */
    accountId;
    /** @deprecated Use session.account.type instead */
    accountType;
    systemModes;
    frequencyMinutes;
    utilizationEnabled;
    docSizeSetting;
    cloudProvider;
    subAccount;
    accountLogsSuspensionState;
    accountCreatedDate;
    planStartDate;
    username;
    fullName;
    accountName;
    liftrAccount;
    utilizationSettings;
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], UserSummary.prototype, "accountCreatedDate", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], UserSummary.prototype, "planStartDate", void 0);
class IntercomIntegration {
    isDisabled = false;
}
class AmplitudeIntegration {
    isDisabled = false;
}
class FullstoryIntegration {
    isDisabled = false;
}
class AskNicelyIntegration {
    isDisabled = false;
    emailHash;
    forceOpenConversation = false;
}
class RumIntegration {
    isDisabled = false;
}
class Integrations {
    intercom;
    amplitude;
    fullstory;
    askNicely;
    rum;
}
__decorate([
    Type(() => IntercomIntegration),
    __metadata("design:type", IntercomIntegration)
], Integrations.prototype, "intercom", void 0);
__decorate([
    Type(() => AmplitudeIntegration),
    __metadata("design:type", AmplitudeIntegration)
], Integrations.prototype, "amplitude", void 0);
__decorate([
    Type(() => FullstoryIntegration),
    __metadata("design:type", FullstoryIntegration)
], Integrations.prototype, "fullstory", void 0);
__decorate([
    Type(() => AskNicelyIntegration),
    __metadata("design:type", AskNicelyIntegration)
], Integrations.prototype, "askNicely", void 0);
__decorate([
    Type(() => RumIntegration),
    __metadata("design:type", RumIntegration)
], Integrations.prototype, "rum", void 0);
export class SessionModel {
    featureFlags;
    appAdminPanelUrl;
    userSettings;
    accountSettings;
    plan;
    user = new UserModel();
    account = new AccountModel();
    integrations;
    userSummary = new UserSummary();
    userSession = new UserSession();
}
__decorate([
    Type(() => UserSettings),
    __metadata("design:type", UserSettings)
], SessionModel.prototype, "userSettings", void 0);
__decorate([
    Type(() => AccountSettings),
    __metadata("design:type", AccountSettings)
], SessionModel.prototype, "accountSettings", void 0);
__decorate([
    Type(() => PlanDetailsModel),
    __metadata("design:type", PlanDetailsModel)
], SessionModel.prototype, "plan", void 0);
__decorate([
    Type(() => UserModel),
    __metadata("design:type", Object)
], SessionModel.prototype, "user", void 0);
__decorate([
    Type(() => AccountModel),
    Transform((account, session) => ({ ...account, type: session.userSummary.accountType })),
    __metadata("design:type", Object)
], SessionModel.prototype, "account", void 0);
__decorate([
    Type(() => Integrations),
    __metadata("design:type", Integrations)
], SessionModel.prototype, "integrations", void 0);
__decorate([
    Type(() => UserSummary),
    __metadata("design:type", Object)
], SessionModel.prototype, "userSummary", void 0);
__decorate([
    Type(() => UserSession),
    __metadata("design:type", Object)
], SessionModel.prototype, "userSession", void 0);
//# sourceMappingURL=session.js.map